import { BudgetStructuresResolver } from './budget-structures.resolver';
import { ClientsResolver } from './clients.resolver';
import { ConjoncturalParametersResolver } from './conjonctural-parameters.resolver';
import { DashboardResolver } from './dashboard.resolver';
import { FunctionalArticlesResolver } from './functional-articles.resolver';
import { HiringPlanResolver } from './hiring-plan.resolver';
import { MonitoringResolver } from './monitoring.resolver';
import { OrganigramsResolver } from './organigram.resolver';
import { PaymentSectionResolver } from './payment-section.resolver';
import { PensionResolver } from './pension.resolver';
import { ProfessionalStatusResolver } from './professional-status.resolver';
import { ReportCategoriesResolver } from './report-categories.resolver';
import { ReportCustomResolver } from './report-custom.resolver';
import { ReportStructuresResolver } from './report-structure.resolver';
import { ReportsAdvancedResolver } from './reports-advanced.resolver';
import { ScaleAmountResolver } from './scale-amount.resolver';
import { ScenarioResolver } from './scenario.resolver';
import { StoryLineResolver } from './story-line.resolver';
import { SubstitutionScalePaymentResolver } from './substitution-scale-payment.resolver';
import { UiItemsResolver } from './ui-items.resolver';
import { UniverseResolver } from './universe.resolver';
import { UserTagResolver } from './user-tag.resolver';
import { UsersResolver } from './users.resolver';
import { WorkflowExecutionsResolver } from './workflow-executions.resolver';

export const resolverProviders = [
    ClientsResolver,
    UsersResolver,
    BudgetStructuresResolver,
    ReportCategoriesResolver,
    ReportsAdvancedResolver,
    PaymentSectionResolver,
    ProfessionalStatusResolver,
    WorkflowExecutionsResolver,
    ReportStructuresResolver,
    MonitoringResolver,
    UniverseResolver,
    OrganigramsResolver,
    DashboardResolver,
    UiItemsResolver,
    ScenarioResolver,
    StoryLineResolver,
    FunctionalArticlesResolver,
    SubstitutionScalePaymentResolver,
    HiringPlanResolver,
    PensionResolver,
    ReportCustomResolver,
    UserTagResolver,
    ScaleAmountResolver,
    ConjoncturalParametersResolver
];
